import { type VFC } from 'react'

const Spinner: VFC = () => (
  <span className="u-display--inline-block">
    <span
      className="a-LoadingIndicator e-LoadingIndicatorSpinner a-loadDataSpinner u-color--white u-padding-x-small"
      role="progressbar"
    >
      <svg viewBox="22 22 44 44">
        <circle cx="44" cy="44" r="20" fill="none" strokeWidth="3.6" />
      </svg>
    </span>
  </span>
)

export default Spinner
